import { GridCellProps } from '@progress/kendo-react-grid';
import { FC } from 'react';
import GridCellBase from 'src/components/GridCellBase';

const POItemsCompleteField: FC<GridCellProps> = (props) => {
  const { poItemsCompleted } = props.dataItem;

  return (
    <GridCellBase
      {...props}
      rowSelectionEnabled={true}
      title={poItemsCompleted}
      style={{
        backgroundColor: poItemsCompleted === 'Y' ? '#C3D7B9' : '#EFB2B2',
        textAlign: 'center',
      }}
      className="overflow-auto"
    >
      <span>{poItemsCompleted}</span>
    </GridCellBase>
  );
};

export default POItemsCompleteField;
